import { execAdmin } from '@src/apis/reware/utils';

import type {
  BatchCreateResult,
  PricingRuleInput,
  AddToPricingImportExecVariables,
  AddToPricingImportExecResponse,
} from './types';

export interface AddToPricingImportArgs {
  partnerId: number;
  pricingDiscountId: number;
  rules: PricingRuleInput[];
}

/**
 * Add pricing rules to an existing import session.
 * The pricingDiscountId must come from a prior call to startPricingImport.
 */
export const addToPricingImport = async ({
  partnerId,
  pricingDiscountId,
  rules,
}: AddToPricingImportArgs): Promise<BatchCreateResult> => {
  const query = `
    mutation addToPricingImport(
      $partnerId: Int!
      $pricingDiscountId: Int!
      $rules: [PricingRuleInput!]!
    ) {
      partner(id: $partnerId) {
        addToPricingImport(
          pricingDiscountId: $pricingDiscountId
          rules: $rules
        ) {
          created
          errors {
            index
            message
          }
        }
      }
    }
  `;

  const data = await execAdmin<
    AddToPricingImportExecVariables,
    AddToPricingImportExecResponse
  >(query, { variables: { partnerId, pricingDiscountId, rules } });

  return data.partner.addToPricingImport;
};
